const lookupTable:Record<string, string> = {
  MTC: 'MATIC'
}

// override display text in the UI
export function factionToDisplayname(faction:string|undefined) {
  return lookupTable[faction || ''] || faction
}
